(function() {

    /**
     * Products collection
     *
     * @param products
     * @constructor
     */
    function Products(models) {

        this.models;
        this.events;

        this._init = function() {
            this.models = clone(models);
            this.events = $({});
        }

        /**
         * Callbacks used for sorting
         */
        this.sortMethods = {
            price: function(a, b) {
                return a.price - b.price;
            },
            published: function(a, b) {
                return new Date(b.published_at) - new Date(a.published_at);
            }
        }

        /**
         * Sort collection by given field
         *
         * @param field
         */
        this.sortBy = function(field) {
            if(this.sortMethods[field]) {
                var m = this.models.sort(this.sortMethods[field]);
                this.triggerEvent('update', m);
            }
        }

        /**
         * Replace existing collection with new models
         *
         * @param models
         */
        this.update = function(m) {
            this.models = clone(m);
            this.triggerEvent('update', m);
        }

        /**
         * Fire a new collection event
         *
         * @param event
         * @param payload
         */
        this.triggerEvent = function(event, payload) {
            this.events.trigger(event, {
                models: payload
            });
        }

        this._init();
    }

    /**
     * Initialize, exclude set products by default
     */
    var excludeTypes = ['sample', 'option'];

    collection = $.grep(collection, function(product) {
        return ($.inArray(product.type, excludeTypes) === -1);
    });

    var products = new Products(collection);

    $(function() {

        var $body = $('body');
        var $container = $('.sortable-collection__items');
        var select = '.sortable-collection__sort-select';
        var source = $('#sortable-collection-template').html();
        var template = Handlebars.compile(source);

        /**
         * Render updates to DOM
         *
         * @param models
         */
        function render(m) {
            //console.log(collectionHandle);
            $container.html(template({
                models: m,
                handle: collectionHandle
            })).removeClass('is-loading');
        }

        /**
         * Event handlers
         */
        products.events.on('update', function(e, m) {
            render(m.models);
        });

        $body.on('change', select, function() {

            var field = $(this).val();

            if(field === 'default') {
                // Load default collection order
                products.update(collection);
            } else {
                // Else apply sort to existing collection
                products.sortBy(field);
            }
        });

        render(products.models);
    });
})();